import React from 'react';
import { FadeIn } from './FadeIn';
import { Moon } from 'lucide-react';
export function HookSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-101">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-102">
        <FadeIn data-id="element-103">
          <div className="flex justify-center mb-6" data-id="element-104">
            <div className="w-12 h-12 rounded-full bg-teal-50 flex items-center justify-center" data-id="element-105">
              <Moon className="w-6 h-6 text-teal-600" data-id="element-106" />
            </div>
          </div>
          <p className="text-xl md:text-2xl font-serif italic text-gray-800 leading-relaxed" data-id="element-107">
            "Son las 2 de la mañana. Intentas girarte en la cama y, de repente,
            ese rayo eléctrico recorre tu glúteo hasta el talón. Te quedas
            congelada, conteniendo la respiración, rezando para que el dolor se
            detenga. Haces lo que todas: tomas otro analgésico y buscas un video
            de estiramientos en YouTube. Pero el dolor no solo no se va, sino
            que cada mañana se siente más pesado."
          </p>
        </FadeIn>
      </div>
    </section>;
}